export default __webpack_public_path__ + "static/media/009-photo-album.f1a75bdf.png";